// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"4e2d551b","693":"8e3ebced","957":"182f283d"}[chunkId] + ".chunk.css";
};